import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function CTASection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="relative bg-[#1B2A4A] py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#7FBF3F] rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#7FBF3F] rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>
      <div className="absolute top-0 left-0 right-0 h-1 bg-[#7FBF3F]"></div>

      <div
        ref={ref as (el: HTMLDivElement | null) => void}
        className={`relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center reveal ${isVisible ? "visible" : ""}`}
      >
        <div className="inline-flex items-center gap-2 bg-[#F36F21]/90 text-white text-xs font-bold px-4 py-2 rounded-full mb-6">
          <i className="ri-alarm-warning-line"></i>Limited Plots Available
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Book Your Site Visit Today
        </h2>
        <p className="text-white/70 text-base md:text-lg mb-10 max-w-2xl mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
          Premium villa plots on Sarjapur Road, Bangalore. Contact us now for pricing, availability, and a free site visit.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:+919945124133" className="btn-hover inline-flex items-center justify-center gap-2 bg-white text-[#1B2A4A] hover:bg-gray-100 font-bold px-8 py-4 rounded-xl cursor-pointer whitespace-nowrap text-base">
            <i className="ri-phone-line text-[#F36F21]"></i>Call Now
          </a>
          <a
            href="https://wa.me/919945124133?text=Hi%2C%20I%27m%20interested%20in%20your%20plots%20near%20Sarjapur%20Road.%20Please%20share%20details."
            target="_blank"
            rel="nofollow noreferrer"
            className="btn-hover cta-pulse inline-flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-bold px-8 py-4 rounded-xl cursor-pointer whitespace-nowrap text-base"
          >
            <i className="ri-whatsapp-line"></i>WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
}
